import { useState } from "react";
import { useEventListener } from "./useEventListener.js";
const useOnEscape = (handler, options = {})=>{
    const { active = true } = options;
    const [ref, setRef] = useState(null);
    useEventListener('keydown', (event)=>{
        if ('Escape' !== event.key || false === active) return;
        handler();
        event.preventDefault();
        event.stopPropagation();
    }, options.element ?? ref);
    return setRef;
};
export { useOnEscape };
